import { useT } from '../../hooks/useT';
import styles from './ImageBlock.module.css';

function ImageBlock({ src = '', alt = '', captionKey = '', align = 'center', maxWidth = '100%' }) {
  const t = useT();

  return (
    <figure className={styles.figure} style={{ textAlign: align, maxWidth }}>
      {src ? (
        <img src={src} alt={alt || t(captionKey)} className={styles.image} />
      ) : (
        <div className={styles.placeholder}>No image</div>
      )}
      {captionKey && <figcaption className={styles.caption}>{t(captionKey)}</figcaption>}
    </figure>
  );
}

export default ImageBlock;
